import styled from 'styled-components';
import { media } from '../../styles/theme';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.espaco.md};
  padding: ${({ theme }) => theme.espaco.xl};
  background-color: ${({ theme }) => theme.cores.card};
  border: 1px solid ${({ theme }) => theme.cores.border};
  border-radius: ${({ theme }) => theme.raio.card};

  ${media.mobile} {
    padding: ${({ theme }) => theme.espaco.lg};
  }
`;

export const Cabecalho = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.espaco.sm};

  h2 {
    font-size: ${({ theme }) => theme.fonte.h3};
    color: ${({ theme }) => theme.cores.ink};
  }

  ${media.mobile} {
    button {
      flex-basis: 100%;
    }
  }
`;

export const Aviso = styled.p`
  font-size: ${({ theme }) => theme.fonte.body};
  color: ${({ theme }) => theme.cores.inkMuted};
`;

export const Grade = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: ${({ theme }) => theme.espaco.md};

  ${media.mobile} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const Miniatura = styled.div<{ $capa?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  border: ${({ $capa }) => ($capa ? 2 : 1)}px solid ${({ theme, $capa }) => ($capa ? theme.cores.accent : theme.cores.border)};
  border-radius: ${({ theme }) => theme.raio.md};
  background-color: ${({ theme }) => theme.cores.surface};
  overflow: hidden;
`;

export const Imagem = styled.img`
  width: 100%;
  aspect-ratio: 1;
  object-fit: contain;
  cursor: zoom-in;
  background-color: ${({ theme }) => theme.cores.card};
`;

export const Selo = styled.span`
  position: absolute;
  top: ${({ theme }) => theme.espaco.sm};
  left: ${({ theme }) => theme.espaco.sm};
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.espaco.xs};
  padding: 2px ${({ theme }) => theme.espaco.sm};
  border-radius: ${({ theme }) => theme.raio.pill};
  background-color: ${({ theme }) => theme.cores.primary};
  color: ${({ theme }) => theme.cores.inkInverse};
  font-size: ${({ theme }) => theme.fonte.caption};
  font-weight: 600;

  svg {
    color: ${({ theme }) => theme.cores.accent};
  }
`;

export const AcoesFoto = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.espaco.xs};
  padding: ${({ theme }) => theme.espaco.xs};
  border-top: 1px solid ${({ theme }) => theme.cores.border};
  background-color: ${({ theme }) => theme.cores.card};
`;

export const ImagemAmpliada = styled.img`
  display: block;
  max-width: 100%;
  max-height: 70vh;
  margin: 0 auto;
  object-fit: contain;
`;
